import { render, staticRenderFns } from "./TeacherMonthlyAttendance.vue?vue&type=template&id=0b7120e3&scoped=true&"
import script from "./TeacherMonthlyAttendance.vue?vue&type=script&lang=js&"
export * from "./TeacherMonthlyAttendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7120e3",
  null
  
)

export default component.exports